/* The mobile buy bar reveals itself only while the real add-to-cart button is off screen. */
if (!customElements.get('atlas-sticky-buy')) {
  customElements.define(
    'atlas-sticky-buy',
    class AtlasStickyBuy extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.watch);
        if (!this.target) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            // Only hide while the real button is actually visible. Once it has scrolled
            // past, the bar carries the action.
            this.hidden = entry.isIntersecting;
          },
          // A little margin so the bar does not flicker in and out as the button grazes
          // the edge of the viewport.
          { rootMargin: '-24px 0px -24px 0px' }
        );
        this.observer.observe(this.target);

        // Dawn swaps the price element's innerHTML on variant change. Mirroring it here
        // keeps the bar honest without adding the bar to Dawn's own swap list.
        const price = document.getElementById(`price-${this.target.id.split('-').pop()}`)
          || document.querySelector('.price');
        const mirror = this.querySelector('[data-atlas-stickybuy-price]');
        if (price && mirror) {
          this.priceObserver = new MutationObserver(() => {
            const now = price.querySelector('.price-item--sale, .price-item--regular');
            if (now) mirror.textContent = now.textContent.trim();
          });
          this.priceObserver.observe(price, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.priceObserver?.disconnect();
      }
    }
  );
}
